module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Sort3-4642190fa609d269bc551d13fb5b709b.svg";